<template>
  <div>
    <div>
      <div class="footer">
        <div
          class="link"
          @click="goTo('https://www.piratenwelt.at/impressum/')"
        >
          Impressum
        </div>
        <div
          class="link"
          @click="goTo('https://www.piratenwelt.at/datenschutz/')"
        >
          Datenschutz
        </div>
        <div class="link" @click="goTo('https://www.piratenwelt.at/kontakt/')">
          Kontakt
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    goTo(url) {
      window.open(url);
    }
  }
};
</script>

<style scoped>
.footer {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 15px;
  min-width: 100%;
}

.link {
  padding-right: 10px;
  padding-left: 10px;
  color: rgba(255, 255, 255, 0.5);
}
</style>
